import React from 'react';
const Banner = () => {
  return <div className="bg-[#042A1D] text-white p-2 overflow-hidden relative" data-id="element-208">
      <div className="marquee-container" data-id="element-209">
        <div className="marquee-content" data-id="element-210">
          <span className="font-bold uppercase mr-2" data-id="element-211">ADVERTORIAL</span>
          <span className="mx-2" data-id="element-212">|</span>
          <span className="mr-2" data-id="element-213">TRENDING IN THE US</span>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/28Sq8eaSgtYSTw9CYf39XA/pasted-image.png" alt="US Flag" className="inline-block h-4 w-6" data-id="element-214" />
          <span className="mx-8" data-id="element-215"></span>
          <span className="font-bold uppercase mr-2" data-id="element-216">ADVERTORIAL</span>
          <span className="mx-2" data-id="element-217">|</span>
          <span className="mr-2" data-id="element-218">TRENDING IN THE US</span>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/28Sq8eaSgtYSTw9CYf39XA/pasted-image.png" alt="US Flag" className="inline-block h-4 w-6" data-id="element-219" />
          <span className="mx-8" data-id="element-220"></span>
        </div>
      </div>
      <style jsx data-id="element-221">{`
        .marquee-container {
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
        }
        .marquee-content {
          display: inline-block;
          animation: marquee 20s linear infinite;
          padding-right: 100%; /* Ensure no gap at the end of animation */
        }
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </div>;
};
export default Banner;